export default "/packs/images/coins@2x~87e1927a7257712edfc3c9c47a1694bd.png";